import * as actions from "./actionsTypes";

const initialData = {
  loaderPositionHistory: false,
  positionHistory: null,
  positionHistoryFail: null,
  positionHistoryFormError: null,
};

export default function PositionHistoryReducer(state = initialData, action) {
  switch (action.type) {
    case actions.LOADER_POSITIONHISTORY:
      return { ...state, loaderPositionHistory: action.payload };

    case actions.GET_POSITIONHISTORY:
      return { ...state, positionHistory: action.payload };

    case actions.POSITIONHISTORY_FAIL:
      return { ...state, positionHistoryFail: action.payload };

    
    case actions.FORM_POSITIONHISTORY_FAIL:
      return { ...state, positionHistoryFormError: action.payload };

    default:
      return state;
  }
}
